export default {
    title:'Contact Us',
    h3:`We’re not afraid of “the talk.” After all, successful relationships require clear communication. So, if you have a question or feedback, send us a message and we’ll get back to you right away.`,
    popup:{
        title:`Thank you for your message`,
        message:`We will be in touch shortly`
    },
    actions:{
        send:`Send message`,
        continue:`Continue to site`
    }
}


// WEBPACK FOOTER //
// ./assets/strings/contact.js